export default {
  install(Vue, options) {
    window.ff = Vue.observable({ ...options })
    const featureOptions = Vue.observable({ ...options })
    function getFeatures() {
      return { ...featureOptions }
    }

    Vue.prototype.$setFeatures = function (queryParams) {
      let features = Object.keys(featureOptions)

      for (let feature of features) {
        const fromQuery = queryParams[feature] !== undefined
        if (fromQuery || window.ff[feature] !== undefined) {
          let value = fromQuery ? queryParams[feature] : window.ff[feature]
          // The declared default decides the type: numeric flags must survive
          // this pass, otherwise Boolean() collapses them to true.
          const declared = options[feature]
          if (typeof declared === 'string') {
            value = String(value)
          } else if (typeof declared === 'number') {
            const parsed = value === '' ? NaN : Number(value)
            value = Number.isFinite(parsed) ? parsed : declared
          } else {
            value = value === 'false' || value === '0' ? false : Boolean(value)
          }

          Vue.set(featureOptions, feature, value)
          Vue.set(window.ff, feature, value)
        }
      }
    }

    window.setFeature = function (feature, value) {
      if (window.ff[feature] == undefined) {
        console.error(`feature flag ${feature} not found`)
        return
      }
      Vue.set(featureOptions, feature, value)
      Vue.set(window.ff, feature, value)
    }

    Vue.prototype.$features = function () {
      return getFeatures()
    }

    Vue.prototype.$ff = window.ff
  },
}
